module.exports = __webpack_public_path__ + "static/media/docs.c8c490b3.svg";